import { render, staticRenderFns } from "./Affirm.vue?vue&type=template&id=58efb8c6&scoped=true&"
import script from "./Affirm.vue?vue&type=script&lang=js&"
export * from "./Affirm.vue?vue&type=script&lang=js&"
import style0 from "./Affirm.vue?vue&type=style&index=0&id=58efb8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58efb8c6",
  null
  
)

export default component.exports